module.exports = __webpack_public_path__ + "img/eyes-01.5046eecd.svg";